export default __webpack_public_path__ + "static/media/print.61383321.svg";